import PaginationComponent from './PaginationComponent';

type TablePaginationProps = {
  total: number;
  offset: number;
  limit: number;
  setLimit: (limit: number) => void;
  setOffset: (offset: number) => void;
  unit?: string;
  pageSizes?: string[];
  scrollToTop?: boolean;
  className?: string;
};

function TablePagination({
  total,
  offset = 0,
  limit,
  setLimit,
  setOffset,
  unit = '',
  pageSizes = ['10', '20', '50'],
  scrollToTop = false,
  className,
}: TablePaginationProps) {
  const scrollPageToTop = () => {
    if (scrollToTop) {
      window.scrollTo(0, 0);
    }
  };

  const handleLimitChange = (value: string) => {
    const newLimit = Number(value);
    setLimit(newLimit);

    // Reset to first page only when limit is greater than total
    if (newLimit >= total) {
      setOffset(0);
      scrollPageToTop();
    }
    // Adjust offset if it would exceed total
    else if (offset + newLimit > total) {
      const newOffset = Math.max(0, total - newLimit);
      setOffset(newOffset);
      scrollPageToTop();
    }
  };

  const handlePrevPage = () => {
    setOffset(Math.max(0, offset - limit));
    scrollPageToTop();
  };

  const handleNextPage = () => {
    setOffset(Math.min(offset + limit, total));
    scrollPageToTop();
  };

  return (
    <PaginationComponent
      total={total}
      offset={offset}
      limit={limit}
      unit={unit}
      pageSizes={pageSizes}
      handlePrevPage={handlePrevPage}
      handleNextPage={handleNextPage}
      handleLimitChange={handleLimitChange}
      className={className}
    />
  );
}

export { TablePagination };
